import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { UISize, UIVariant } from '../types';
import { CircleBone } from '../SkeletonLoader';
import { defaultUserImagePath } from '@gik/core/constants';

export interface IAvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: UIVariant;

  /**
   * Size the button on a fixed scale
   */
  size?: UISize;

  /**
   * use circular shape (this will apply border-radius: 50% with a fixed width and height)
   */
  circle?: boolean;

  /**
   * use rounded corners (default)
   */
  rounded?: boolean;

  /**
   * use pill shaped corners
   */
  pill?: boolean;

  /**
   * use squared corners
   */
  squared?: boolean;

  loading?: boolean;

  imageUrl?: string;

  showBorder?: boolean;
}

export default function Avatar({
  children,
  className,
  loading,
  variant = 'default',
  imageUrl,
  pill,
  circle = true,
  squared,
  rounded,
  size = 'base',
  showBorder = false,
  ...otherProps
}: IAvatarProps): React.ReactElement {
  const bem = bemBlock('avatar');
  const blockClasses = bem(
    null,
    [
      { [variant]: variant },
      { [`size-${size}`]: size },
      { pill },
      { circle },
      { squared },
      { rounded },
      { loading },
      { 'show-border': showBorder },
    ],
    className
  );

  return (
    <div
      className={blockClasses}
      {...otherProps}
      style={{
        backgroundImage: `url(${imageUrl ? imageUrl : defaultUserImagePath})`,
      }}
    >
      {loading && <CircleBone />}
      {!loading && children}
    </div>
  );
}
